var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-mask",on:{"mousedown":_vm.handleMouseDown}},[_vm._t("default",[_c('div',{staticClass:"editor",style:(_vm.style)},[_c('Container')],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }